export default __webpack_public_path__ + "static/media/stripe-payment.07e4b669.png";